import { createContext, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import clienteAxios from "../config/clienteAxios";

const ProductContext = createContext();

const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [resetFlag, setResetFlag] = useState();
  const [product, setProduct] = useState({});
  const [subProduct, setSubProduct] = useState({});

  const navigate = useNavigate();

  const getDetalleProductoByParams = async (title) => {
    try {
      const { data } = await clienteAxios.get(`/subproduct/${title}`);
      setSubProduct(data.subproductById[0]);
    } catch (error) {
      console.log(error);
    }
  };

  const getAllProducts = async ({ onlyTitleAndIcon, visible }) => {
    try {
      const params = {visible};
      if (onlyTitleAndIcon) {
        params.onlyTitleAndIcon = onlyTitleAndIcon;
      }
      const { data } = await clienteAxios.get("/product", {
        params
      });
      setProducts(data?.allProducts);
    } catch (error) {
      console.log(error);
    }
    finally {
      setLoading(false);
    }
  };

  const getProductsByBody = async ({title}) => {
    try {
      const { data } = await clienteAxios.get(`/product/${title}`);
      setProduct(data.productsByBody[0]);
    } catch (error) {
      toast.error(error);
      navigate("/error404");
    }
  };

  const handleVisibility = (product) => {
    setProducts(
      products.map((item) => {
        if (item._id === product._id) {
          if (item.visible) {
            item.visible = false;
          } else {
            item.visible = true;
          }
        }
        return item;
      })
    );
  };

  const handlePublishButton = (id) => {
    const productsEdit = products.map((product) => {
      if (product._id === id) {
        return { ...product, publish: true };
      }
      return product;
    });
    setProducts(productsEdit);
  };

  const handleProductUpdate = async () => {
    try {
      const promises = products.map((item) => clienteAxios.put("/product", item));
      const results = await Promise.all(promises);
      toast.success("Se actualizaron todos los productos");
    } catch (error) {
      toast.error("error");
    }
  };

  const deleteProduct = async (id) => {
    const productEdit = products?.map((producto) =>
      producto._id === id ? { ...producto, deleted: true } : producto
    );
    try {
      await Promise.all(productEdit.map((item) => clienteAxios.put("/product", item)));
    } catch (error) {
      toast.error("error");
    }
    setProducts(productEdit);
  };

  return (
    <ProductContext.Provider
      value={{
        products,
        resetFlag,
        setResetFlag,
        setProducts,
        getDetalleProductoByParams,
        getProductsByBody,
        getAllProducts,
        handleVisibility,
        handlePublishButton,
        handleProductUpdate,
        product,
        setProduct,
        deleteProduct,
        subProduct,
        loading
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};

export { ProductProvider };

export default ProductContext;
